/* @ts-expect-error this library has no types */
import { APIFilterOP } from '@jagu/rest-api-filters-client/apiFilters'

// TODO: Figure out how to add ts-expect-error for the line below
export {
  APIFilters,
  APIFilterOP,
  APIFilterDataType,
  APIFilterDataTypeAllowedOperations,
} from '@jagu/rest-api-filters-client/apiFilters'

function addFilter(
  filterKey: string,
  value?: string | number,
  currentFilter?: unknown
) {
  if (value === undefined) {
    return {}
  }
  const newFilter = {
    [APIFilterOP.EQUALS]: {
      [filterKey]: value,
    },
  }
  if (currentFilter === undefined) {
    return newFilter
  }

  if (Array.isArray(currentFilter)) {
    currentFilter.push(newFilter)
  }
}

function addNotEqualsFilter(
  filterKey: string,
  value: string | number,
  currentFilter?: unknown
) {
  const newFilter = {
    [APIFilterOP.NOT_EQUALS]: {
      [filterKey]: value,
    },
  }
  if (currentFilter === undefined) {
    return newFilter
  }

  return {
    [APIFilterOP.AND]: [currentFilter, newFilter],
  }
}

export { addNotEqualsFilter, addFilter }
